module.exports = __webpack_public_path__ + "static/media/latvia-flag.6acac58f.png";